import { apiSalesWeb } from '@shared/config';
import { IPlanDuration } from '@shared/types';

export type ICreateRequestPlanInput = Array<
  IPlanDuration & { planDurationId: string }
>;

export interface ICreateRequestPlanOutput {
  id: string;
}

export function createRequestPlanInput(payload: ICreateRequestPlanInput) {
  return apiSalesWeb.post<ICreateRequestPlanOutput>('/request-plan', payload);
}
